module.exports = __webpack_public_path__ + "static/media/the-legend-of-mr-rager.1770cb38.jpg";